/**
 * Roda `fn` quando o navegador estiver ocioso (após first paint).
 * Fallback para setTimeout em browsers sem requestIdleCallback (Safari).
 * Usado para deferir trabalho não-crítico do boot (telemetria, push,
 * heartbeats, logs) para não competir com FCP/TTI.
 */
export const runWhenIdle = (fn: () => void, timeout = 2000): void => {
  if (typeof window === "undefined") return;
  const w = window as unknown as {
    requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
  };
  if (typeof w.requestIdleCallback === "function") {
    w.requestIdleCallback(fn, { timeout });
  } else {
    window.setTimeout(fn, 1);
  }
};

/** Aguarda o evento `load` (ou roda imediatamente se já carregou). */
export const runAfterLoad = (fn: () => void): void => {
  if (typeof window === "undefined") return;
  if (document.readyState === "complete") {
    runWhenIdle(fn);
  } else {
    window.addEventListener("load", () => runWhenIdle(fn), { once: true });
  }
};
